module.exports = __webpack_public_path__ + "img/lt.5fbdf2cf.png";